module.exports = __webpack_public_path__ + "img/media-bg.01b88aa.webp";